<section class="cz-error" *ngIf="language$ | async as language">
    <header class="header">
        <div class="container-fluid">
            <div class="row middle-xs">
                <div class="col-xs-8">
                    <div class="row middle-xs">
                        <div class="col-xs-3">
                            <img src="/assets/images/global/Comfort-Zone-Logo.png" alt="Comfort Zone" />
                        </div>
                        <div class="col-xs-9">
                            <!-- <h1 class="no-margin h3 tag">Welcome to the Acme Human Resources Comfort Zone</h1> -->
                            <h1 class="no-margin h3 tag truncate" [innerHTML]="'$login_tagline' | translate"></h1>
                        </div>
                    </div>
                </div>
                <div class="col-xs-4 end-xs partner-logo-container" *ngIf="logoHref && logoHref.length > 1">
                    <img class="partner-logo" src="{{logoHref}}" alt="Partner logo" />
                </div>
            </div>
        </div>
    </header>

    <mat-card class="login-card" *ngIf="displayErrorContent">
        <mat-toolbar color="primary">
            <mat-toolbar-row>
                <h3 *ngIf="displayErrorContent" [innerHTML]="'$sso_error_item_' + this.msgNum | translate" class="truncate"></h3>
            </mat-toolbar-row>
        </mat-toolbar>
        <mat-card-content>

            <!-- Initial Error Content -->
            <div class="row" *ngIf="displayErrorContent">
                <div class="col-xs-12">
                    <div>
                        <div class="row action-buttons middle-xs between-xs"  style="overflow-y: auto; max-height: 20em;">
                            <div class="col-xs-12">
                                <div [innerHTML]="errorMessage ? sanitizer.bypassSecurityTrustHtml(errorMessage.message) : ('$sso_error_item_' + this.msgNum + '_default_value' | translate)"></div>
                            </div>
                            <div class="col-xs-4 end-xs">
                            </div>
                        </div>
                        <div class="row help-links top-xs">
                            <div class="col-xs-3">
                            </div>
                            <div class="col-xs-3">
                            </div>
                            <div class="col-xs-3">
                            </div>
                            <div class="col-xs-3">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </mat-card-content>
    </mat-card>


    <footer class="footer">
        <p class="text-center font-size-small no-margin">
            <span (click)="termsOfUseDialog()" [innerHTML]="'$login_footer_terms_label' | translate"></span> | <span (click)="privacyPolicyDialog()" [innerHTML]="'$login_footer_privacy_policy_label' | translate"></span>
        </p>
    </footer>
</section>
